import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class HtmlViewerAPI extends ComponentAPI {
    getData() {
        return this.state.data;
    }
}
export default HtmlViewerAPI;
//# sourceMappingURL=html-viewer-api.js.map